<script setup lang="ts">
import eventBus from '@/utils/eventBus.js';
import { eventKeys } from '@/utils/eventKeys';

// MCS 저장하기 클릭 시
const onClickSaveSettingsMcs = () => {
  eventBus.emit(eventKeys.MCS_SAVE);
};
</script>

<template>
  <button
    @click="onClickSaveSettingsMcs"
    class="button-icon button-dim button-rounded"
  >
    MCS 저장
  </button>
</template>

<style scoped></style>
